import { LocalCostResultDTOCategoryEnum } from 'api';

export const displayLocalCostCategory = (category: LocalCostResultDTOCategoryEnum) => {
  switch (category) {
    case LocalCostResultDTOCategoryEnum.DOC_FEE:
      return 'Documentation Fee';
    case LocalCostResultDTOCategoryEnum.OTHER:
      return 'Other fees';
    case LocalCostResultDTOCategoryEnum.ACCUMULATED:
      return 'Total local fees (excl. THC)';
  }
};
